import classnames from 'clsx'
import { node, string } from 'prop-types'

import { type InferPropsWithDefaults } from 'shared/utils/propTypes'

import './ResponsiveImage.scss'

const PicturePropTypes = {
  className: string,
  children: node.isRequired,
}

const PictureDefaultProps = {
  className: null,
}

type PictureProps = InferPropsWithDefaults<
  typeof PicturePropTypes,
  typeof PictureDefaultProps
>

const Picture = ({ className, children, ...otherProps }: PictureProps) => {
  return (
    <picture
      className={classnames('a-ResponsiveImage', className)}
      {...otherProps}
    >
      {children}
    </picture>
  )
}

Picture.propTypes = PicturePropTypes
Picture.defaultProps = PictureDefaultProps

export default Picture
